export const TOGGLE_CHANGE_OWNERSHIP_MODAL = "TOGGLE_CHANGE_OWNERSHIP_MODAL";
export const OPEN_EXTEND_SUBSCRIPTIONS_MODAL = "OPEN_EXTEND_SUBSCRIPTIONS_MODAL";
export const OPEN_ACTIVATE_SUBSCRIPTIONS_MODAL = "OPEN_ACTIVATE_SUBSCRIPTIONS_MODAL";
export const OPEN_REQUEST_OFFER_MODAL = "OPEN_REQUEST_OFFER_MODAL";
